<template>
  <div class="gap-3 mb-4 lg:w-full mr-2 item-card">
    <strong>{{ title }}</strong>
    <p>{{ value }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: [Number, String],
      required: false,
    },
  },
};
</script>
